"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// styles
require("./styles/cart.scss");
var controllers_1 = require("./controllers");
var services_1 = require("./services");
var routes_1 = __importDefault(require("./config/routes"));
/**
 * @ngdoc module
 * @module rinca.apps.cart
 * @name rinca.apps.cart
 * @packageName rinca.apps
 * @description A module that includes the cart component.
 */
angular.module('rinca.apps.cart', ['ui.router', 'ui.select', 'ngSanitize', '720kb.datepicker', 'pathgather.popeye'])
    .controller('CartController', controllers_1.CartController)
    .service('_cart', services_1.CartService)
    .config(routes_1.default);



//////////////////
// WEBPACK FOOTER
// ./scripts/apps/cart/index.ts
// module id = 420
// module chunks = 0